export const leaveOverviewConstants = {
    GET_OVERVIEW_LIST_SUCCESS: "GET_OVERVIEW_LIST_SUCCESS",
    GET_OVERVIEW_LIST: "GET_OVERVIEW_LIST",
    GET_OVERVIEW_LIST_PAGE: "GET_OVERVIEW_LIST_PAGE",
    UPDATE_OVERVIEW_SUCCESS: "UPDATE_OVERVIEW_SUCCESS",
    UPDATE_OVERVIEW_FAIL: "UPDATE_OVERVIEW_FAIL",
    UPDATE_OVERVIEW: "UPDATE_OVERVIEW",
    CLEAR_MESSAGE: "CLEAR_MESSAGE",
};
